import { createStyles, Header, Group , ThemeIcon, ActionIcon, Container, rem , Text , Avatar , Image , Center , Divider , Title , TypographyStylesProvider , UnstyledButton} from '@mantine/core';
import { IconBrandTwitter, IconMapPin , IconPhone , IconBrandInstagram , IconBrandLinkedin , IconBrandYoutube , IconBrandItch } from '@tabler/icons-react';
import { FooterSimple } from '../Components/Footer';
import {useNavigate} from 'react-router-dom'
import {useEffect} from 'react';

const useStyles = createStyles((theme) => ({
    inner: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: rem(56),
  
      [theme.fn.smallerThan('sm')]: {
        justifyContent: 'flex-start',
      },
    },
  
    links: {
      width: rem(260),
  
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
  
    social: {
      width: rem(260),
  
      [theme.fn.smallerThan('sm')]: {
        width: 'auto',
        marginLeft: 'auto',
      },
    },
  }));
  
  const listData = {
    "footerLink": [
      {
        "link": "#",
        "label": "Copyright @ 2023"
      },
      {
        "link": "/privacy_policy",
        "label": "Privacy Policy"
      },
      {
        "link": "/terms_and_conditions",
        "label": "Terms and Condition"
      }
    ]
  }

function SKJPage() {
    const navigate = useNavigate();
    const { classes} = useStyles();
    useEffect(() => {
      document.getElementById('header')?.scrollIntoView({behavior : 'auto'})
    }, [])
    return (
        <div>
            <Header height={56} mb={20} id='header'>
                <Container className={classes.inner}>
                <Group className={classes.links} spacing={5}>
                </Group>
        
                <Text
                    variant="gradient"
                    gradient={{ from: 'indigo', to: 'cyan', deg: 45 }}
                    sx={{ fontFamily: 'Greycliff CF, sans-serif' }}
                    ta="center"
                    fz="3.5vw"
                    fw={700}
                    onClick={()=>{navigate('/')}}
                    >
                Freak-Bros
                </Text>
        
                <Group spacing={0} className={classes.social} position="right" noWrap>
                <ActionIcon size="lg">
                    <IconBrandTwitter size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandYoutube size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandInstagram size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandItch size="1.1rem" stroke={1.5} />
                </ActionIcon>
                <ActionIcon size="lg">
                    <IconBrandLinkedin size="1.1rem" stroke={1.5} />
                </ActionIcon>
                </Group>
                </Container>
            </Header>
            <Container>
                <Center maw={400} h={200} mx="auto">
                <Image width={200} height={200} radius='xl' src="https://firebasestorage.googleapis.com/v0/b/freak-bros.appspot.com/o/myself.jpg?alt=media&token=e07f0d80-522e-467c-afb1-5873403a3454" alt="Sushant's pic" withPlaceholder />
                </Center>
                <Title color='dimmed' style={{paddingTop:10}}>
                    Sushant Jaiswal
                </Title>
                <Container size='sm'>
                <Divider my="sm" size='md' variant="dashed" />
                </Container>
                <TypographyStylesProvider>
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Highly skilled developer with experience in hybrid app development, game development, web development, and Windows app development. Proficient in a range of programming languages and frameworks, including React Native , React , Unity, HTML/CSS, JavaScript, and C#. Proven ability to develop innovative solutions to complex problems, working independently or as part of a team.</p>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Designed, developed, and published 15 games across various genres, including hypercasual, casual, story-driven, and prototype games, using Unity , Godot , GDevlop5 and Unreal Engine.</p>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<p>Develop and maintain hybrid mobile applications using React Native and Flutter , web application using React and HTML/CSS </p>'
                    }} />
                     <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Game Developer</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Designed and developed 2D and 3D games using Unity , Godot and GDevlop frameworks</li><li>Created game mechanics, levels, and AI behavior using C# programming language</li><li>Collaborated with artists, sound designers, and other developers to create immersive game experiences</li><li>Conducted playtesting and gathered feedback to make iterative improvements to gameplay, user interface, and overall game experience.</li></ul>'
                    }} />
                    <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Hybrid App Developer</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Develop and maintain hybrid mobile applications using React Native and Flutter frameworks</li><li>Implement new features and functionality based on client requirements and user feedback</li><li>Optimize mobile apps for performance and scalability</li><li>Conduct code reviews and ensure adherence to coding standards and best practices</li></ul>'
                    }} />
                    <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Web Developer</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Developed responsive web applications using HTML/CSS, JavaScript , TypeScript, and ReactJS framework</li><li>Implemented complex features such as data visualizations, user authentication, and third-party API integrations</li><li>Conducted browser and device compatibility testing and optimized web applications for performance</li><li>Designed the webpages using different styling frameworks including Material Ui , Bootstrap and W3-Css</li></ul>'
                    }} />
                    <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Windows App Developer</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Designed and developed Windows desktop and mobile applications using C# programming language and Electron Js frameworks</li><li>Implemented features such as database integration, file management, and network communication</li><li>Conducted code reviews and ensured adherence to coding standards and best practices</li><li>Created technical documentation and provided support to end-users</li></ul>'
                    }} />
                     <Divider my="sm" size='sm' variant="dashed" />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Skills</H2>'
                    }} />
                    <div dangerouslySetInnerHTML={{ __html: 
                    '<ul><li>Game development: Unity, Godot , Gdevlop5</li><li>Web development: HTML/CSS, JavaScript, React, Vue, Angular</li><li>Windows app development: C#, Visual Studio , Electron Js</li><li>Agile development methodologies</li><li>Strong proficiency in Unity for game development.</li><li>Solid understanding of game design principles, including gameplay mechanics, user experience, and player engagement.</li><li>Ability to work collaboratively in a team-oriented environment.</li><li>Strong problem-solving and debugging skills to troubleshoot and resolve technical issues.</li><li>Passion for creating mechanically refreshing and immersive games that deliver an exceptional player experience.</li></ul>'
                    }} />
                     <Divider my="sm" size='sm' variant="dashed" />
                     <div dangerouslySetInnerHTML={{ __html: 
                    '<H2>Contact Info</H2>'
                    }} />
                    <UnstyledButton style={{paddingTop:10}}>
                    <Group>
                        <Avatar size={40} color="blue">SJ</Avatar>
                        <div>
                        <Text>Sushant Jaiswal</Text>
                        <Text size="xs" color="dimmed">sushantkjaiswal5@gmail.com</Text>
                        </div>
                    </Group>
                    </UnstyledButton>
                    <br/>
                    <UnstyledButton style={{paddingTop:20}}>
                    <Group>
                        <ThemeIcon variant="light" radius="md" size="xl">
                            <IconPhone />
                        </ThemeIcon>
                        <div>
                        <Text>Phone No.</Text>
                        <Text size="xs" color="dimmed">+91-6203519598</Text>
                        </div>
                    </Group>
                    </UnstyledButton>
                    <br/>
                    <UnstyledButton style={{paddingTop:20}}>
                    <Group>
                        <ThemeIcon variant="light" radius="md" size="xl">
                            <IconMapPin />
                        </ThemeIcon>
                        <div>
                        <Text>Address.</Text>
                        <Text size="xs" color="dimmed">Purani Bazar , Muzaffarpur , Bihar , India</Text>
                        </div>
                    </Group>
                    </UnstyledButton>
                </TypographyStylesProvider>
              </Container>
              <FooterSimple links={listData.footerLink}/>
              
        </div>
  );
}

export default SKJPage;
